import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ButtonEdit } from '../../../components/Buttons';
import { FormContainer, FormInput, FormRow, Label } from '../../../components/form';
import { RHFCalendar, RHFInputText } from '../../../components/rhf';
import { getFormErrorMessage, maxLengthMessage } from '../../../utils/errors';
import { ZASEDANI, ZASEDANI_ZAZNAM } from '../../../constants/field_lengths';
import { IconTooltip } from '../../../components/IconTooltip';

export const MeetingEditForm = ({ onSubmit, meeting, disabled }) => {
    const [processing, setProcessing] = useState(false);

    const defaultValues = {
        date_from: new Date(meeting.date_from),
        date_to: meeting.date_to ? new Date(meeting.date_to) : new Date(meeting.date_from),
        number: meeting.number,
        recording_url: meeting.recording_url ?? ''
    };

    const {
        control,
        formState: { errors, isSubmitting },
        handleSubmit,
        getValues
    } = useForm({
        disabled: processing || disabled,
        defaultValues,
        shouldFocusError: false // hacky way to prevent the date picker from reopening when date validation fails, as it obscures the error message
    });

    useEffect(() => {
        setProcessing(isSubmitting);
    }, [isSubmitting]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <FormContainer>
                <FormRow>
                    <FormInput>
                        <Label htmlFor='date_from' text='Datum od' required />
                        <RHFCalendar
                            control={control}
                            name='date_from'
                            rules={{ required: 'Zadejte datum začátku zasedání' }}
                            placeholder='Datum začátku zasedání'
                            inputProps={{
                                dateFormat: 'd.m.yy'
                            }}
                        />
                        {getFormErrorMessage(errors, 'date_from')}
                    </FormInput>
                    <FormInput>
                        <Label htmlFor='date_to' text='Datum do' info={<>Může zůstat prázdné pro jednodenní zasedání.</>} />
                        <RHFCalendar
                            control={control}
                            name='date_to'
                            placeholder='Datum konce zasedání'
                            inputProps={{
                                dateFormat: 'd.m.yy'
                            }}
                            rules={{
                                validate: (date_to) => {
                                    if (!date_to) return true;
                                    const date_from = getValues('date_from');
                                    return date_to >= date_from ? true : 'Datum konce nesmí předcházet datu začátku'
                                }
                            }}
                        />
                        {getFormErrorMessage(errors, 'date_to')}
                    </FormInput>
                    <FormInput>
                        <Label htmlFor='number' text='Číslo zasedání' required />
                        <RHFInputText
                            control={control}
                            name='number'
                            rules={{
                                required: 'Zadejte číslo zasedání',
                                maxLength: {
                                    value: ZASEDANI.CISLO,
                                    message: maxLengthMessage(ZASEDANI.CISLO)
                                }
                            }}
                            placeholder='č.'
                        />
                        {getFormErrorMessage(errors, 'number')}
                    </FormInput>
                    <FormInput width='lg'>
                        <Label htmlFor='recording_url' text='Odkaz na záznam zasedání' />
                        <RHFInputText
                            control={control}
                            name='recording_url'
                            rules={{
                                maxLength: {
                                    value: ZASEDANI_ZAZNAM.URL,
                                    message: maxLengthMessage(ZASEDANI_ZAZNAM.URL)
                                }
                            }}
                            placeholder='URL nahrávky zasedání'
                        />
                    </FormInput>
                </FormRow>
                <FormRow type='button'>
                    <ButtonEdit
                        type='submit'
                        label='Upravit zasedání'
                        disabled={processing || disabled}
                        loading={processing}
                    />
                </FormRow>
            </FormContainer>
        </form>
    );
};
